import { render, staticRenderFns } from "./ShopModal.vue?vue&type=template&id=5913d79e&"
import script from "./ShopModal.vue?vue&type=script&lang=js&"
export * from "./ShopModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports